import {
    AfterViewInit,
    ComponentFactory,
    ComponentFactoryResolver, ComponentRef,
    Directive,
    ElementRef,
    Input,
    Renderer2,
    ViewContainerRef
} from '@angular/core';
import {MatLegacyProgressSpinner as MatProgressSpinner} from '@angular/material/legacy-progress-spinner';

@Directive({
    selector: '[loaderInButton]'
})
export class LoaderInButtonDirective implements AfterViewInit{
    savedWidth!: number;
    savedHeight!: number;
    private savedWidthStyle!: string;
    private savedHeightStyle!: string;
    private readonly spinnerFactory: ComponentFactory<MatProgressSpinner>;
    private spinner!: ComponentRef<MatProgressSpinner> | null;
    @Input('loaderInButton') set buttonLoader(value: boolean) {
        this.toggle(value);
    }

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private viewContainerRef: ViewContainerRef,
                private renderer: Renderer2,
                private elementRef: ElementRef) {
        this.spinnerFactory = this.componentFactoryResolver.resolveComponentFactory(MatProgressSpinner);
    }

    toggle(condition: boolean) {
        condition ? this.show() : this.destroy()
    }

    show() {
        if (!this.spinner) {
            this.saveButtonSize();
            this.savedWidthStyle = this.elementRef.nativeElement.style.width;
            this.savedHeightStyle = this.elementRef.nativeElement.style.height;

            // Create component
            this.spinner = this.viewContainerRef.createComponent(this.spinnerFactory);
            this.spinner.instance.mode = 'indeterminate';
            this.spinner.instance.diameter = 20;
            // Set current width, height of button
            if (this.savedWidth) {
                this.renderer.setStyle(this.elementRef.nativeElement, 'width', `${this.savedWidth}px`);
            }
            if (this.savedHeight) {
                this.renderer.setStyle(this.elementRef.nativeElement, 'height', `${this.savedHeight}px`);
            }

            this.renderer.addClass(this.elementRef.nativeElement, 'loader-in-button');
            this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
            // Move spinner
            this.renderer.appendChild(this.elementRef.nativeElement, this.spinner.instance._elementRef.nativeElement);
        }
    }

    destroy() {
        if (this.spinner) {
            this.spinner.destroy();
            this.spinner = null;

            this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');
            this.renderer.removeClass(this.elementRef.nativeElement, 'loader-in-button');
            this.restoreButtonSizeStyles();
        }
    }

    ngAfterViewInit(): void {
        this.saveButtonSize();
    }

    private saveButtonSize(): void {
        const button = this.elementRef.nativeElement;

        if (button.style.width === '0px') this.renderer.removeStyle(button, 'width');
        if (button.style.height === '0px') this.renderer.removeStyle(button, 'height');

        const {offsetWidth, offsetHeight} = button;

        if (offsetWidth > 0) this.savedWidth = offsetWidth;
        if (offsetHeight > 0) this.savedHeight = offsetHeight;
    }

    private restoreButtonSizeStyles(): void {
        if (this.savedWidthStyle) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'width', this.savedWidthStyle);
        } else {
            this.renderer.removeStyle(this.elementRef.nativeElement, 'width');
        }

        if (this.savedHeightStyle) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'height', this.savedHeightStyle);
        } else {
            this.renderer.removeStyle(this.elementRef.nativeElement, 'height');
        }
    }
}
